const ru = {
    errorIncorrectPromocode: 'Неверный промокод',
    errorNeedMoreDishes: 'Добавьте еще блюд еще на',
    successText: 'Вы уже можете оформить заказ',

    promocodeError: 'Неверный промокод',
    certificateExistError: 'Неверный сертификат',
    promocodeErrorSubscr: 'Не работает с подпиской',
    promocodeErrorSecond: 'Не работает для повторных заказов',
    certificateError: 'Этот сертификат уже использован',
};

const en = {
    errorIncorrectPromocode: 'Incorrect promocode',
    errorNeedMoreDishes: 'Please add dishes for another',
    successText: 'Now you can proceed to checkout',

    promocodeError: 'Incorrect promo code',
    certificateExistError: 'Incorrect certificate',
    promocodeErrorSubscr: 'Not compatible with subscription',
    promocodeErrorSecond: 'Not compatible with second order',
    certificateError: 'Этот сертификат уже использован',
};

export const locales = {
    ru,
    en,
};
